/* eslint-disable react/prop-types */

import React, { forwardRef, useRef } from 'react';
import { StyledButton, StyledText } from './styled';
import { ButtonProps } from '../types';

const Button: React.ForwardRefRenderFunction<HTMLButtonElement, ButtonProps> = (
	{
		text,
		icon,
		variant: variantProps = 'primary',
		disabled,
		textFontSize14 = false,
		className,
		size = 'md',
		children = text,
		...props
	},
	forwardedRef
) => {
	const disabledClass = disabled ? 'disabled' : '';

	const iconMargin = {
		marginLeft: props.contentOrder === 'reverse' ? 0 : 10,
		marginRight: props.contentOrder === 'reverse' ? 10 : 0,
	};

	const variant = variantProps.includes('outline')
		? 'outline btn-' + variantProps
		: variantProps;

	return (
		<StyledButton
			ref={forwardedRef}
			className={`btn btn-${variant} d-flex ${disabledClass} styled-btn ${
				className ?? ''
			} align-items-center `}
			disabled={disabled}
			size={size}
			{...props}
		>
			{textFontSize14 ? <StyledText>{children}</StyledText> : children}
			{icon ? <span style={iconMargin}>{icon}</span> : null}
		</StyledButton>
	);
};

export default forwardRef(Button);
